<div class="sec-title">
  <h1>Chantier</h1>
</div>
<hr>
<div class="">
<div class="row">
  <div class="col-lg-12 col-sm-12">
    <full-calendar #calendar [options]="calendarOptions" ></full-calendar>
    <!-- [events]="calendarEvents"  -->
  </div>
</div>
</div>